import { DateRangeField, DecoratedFormUnit } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { useTimezone } from '../../../../../../core/hooks';

export const GlobalAudiosNoMatchesReportForm = () => {
  const { $t } = useIntl();
  const tz = useTimezone();

  return (
    <div>
      <div className="row">
        <div className="col-4">
          <DecoratedFormUnit
            label={$t({
              id: 'audit.reportsScreen.noMatches.creationRange',
              defaultMessage: 'Intervalo de carga del archivo',
            })}
          >
            <DateRangeField name={['from', 'to']} tz={tz} />
          </DecoratedFormUnit>
        </div>
      </div>
    </div>
  );
};
